import { AUTH_API_URL } from "config/api";
import { showApiError } from "config/apiToast";
import React, { useState, useEffect } from "react";
import "./login.scss";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useHistory } from 'react-router-dom';
import axios from "axios";

const Login = () => {
  const [submitted, setSubmitted] = useState(false);
  const history = useHistory();
  const [emailError, setEmailError] = useState({});
  const [passwordError, setPasswordError] = useState({});
  const [inputs, setInputs] = useState({
    email: '',
    password: '',
  })

  const { email, password } = inputs;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs(inputs => ({ ...inputs, [name]: value }));
  }

  const formValidation = () => {
    const emailError = {};
    const passwordError = {};

    let isValid = true;


    if (email === '') {
      emailError.emailError = "Email is Required";
      isValid = false;
    }
    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
      emailError.emailNameError = "Invalid Email";
      isValid = false;
    }
    if (password === '') {
      passwordError.logoError = "Password is Required";
      isValid = false;
    }

    // if(messageInputData.)
    setEmailError(emailError)
    setPasswordError(passwordError)
    return isValid;
  }

  const Signin = (e) => {
    console.log("value", e)
    e.preventDefault();
    formValidation();
    if (email && password) {
      axios.post(`${AUTH_API_URL}/auth/login`, { email, password })
        .then((response) => {
          // setOpen(true)

          // const token = response.data.token;
          // localStorage.setItem('mytoken', token);
          const userid = response?.data?.id;
          localStorage.setItem("UseridDash", userid);
          history.push("/verificationemail");

        })
        .catch((err) => {
          showApiError(err);
        })
    }
  }


  return (
    <>
      <section className="mainloginnnn">
        <img className="uppershade img-fluid" src="\assets\main-assets\uppershade.png" />
        <img className="lowershade img-fluid" src="\assets\main-assets\lowershade.png" />
        <div className="imgclasss2">
          <img className="eximgg" src="\assets\main-assets\queckoex.png" />
        </div>
        <div className="mainhead11">
          <h1 className="para111">Log In</h1>
          <p className="para1112">Enter your credentials to Sign in</p>
          <form>
            <div className="parentinput">
              <p className="emailomgg">Email Address</p>
              <input placeholder="Enter email" type="email" name="email" value={email} onChange={handleChange} className='para1113' />

            </div>
            {Object.keys(emailError).map((key) => {
              return <p className="inputErrors">{emailError[key]}</p>
            })}
            <div className="parentinput">
              <p className="emailomgg">Password</p>
              {/* <img className="eyeclasss" src="\assets\main-assets\eye.png"></img> */}
              <input type="password" name="password" value={password} onChange={handleChange} placeholder="Enter password" className='para1114' />
            </div>
            {Object.keys(passwordError).map((key) => {
              return <p className="inputErrors">{passwordError[key]}</p>
            })}
            <div className="maincheckkk">
              <div className="checkdivv">
                {/* <div class="form-check">
                <input
                  class="form-check-inputtt"
                  type="checkbox"
                  value="check"
                  id="defaultCheck1"
                />
              </div> */}
                {/* <div className="checkdivv">
                <div class="form-check">
                  <input className="checkboxxxxinput" type="checkbox" id="vehicle1" name="vehicle1" value="Bike" />
                </div>
              </div> */}
                {/* <div className="checkboxmain">
                  <label class="checkbox" htmlfor="yellow">
                    <input type="checkbox" name="color" value="yellow" id="yellow" />
                    <span class="checkmark"></span>
                  </label>
                  <p className="checkboxpara">Keep me logged in</p>
                </div> */}
              </div>
              {/* <p className="para566">Forgot your password?</p> */}
            </div>
            {/* <Link to="/admin/dashboard"> */}
              <button onClick={Signin} type="submit" className="loginbuttttt">Log in</button>
              <ToastContainer style={{ fontSize: 20 }} />
            {/* </Link> */}
          </form>
        </div>
      </section></>
  );
};

export default Login;
